// Stats Overview Component
// Phase 10: Admin Dashboard
// © 2025 precatio, llc

import React from 'react';

const StatsOverview = ({ stats, onRefresh }) => {
  if (!stats) {
    return <div className="admin-loading">Loading statistics...</div>;
  }

  return (
    <div className="stats-overview">
      <div className="stats-header">
        <h2>Dashboard Statistics</h2>
        <button onClick={onRefresh} className="refresh-btn">
          Refresh
        </button>
      </div>

      <div className="stats-grid">
        {/* Total Users Card */}
        <div className="stat-card">
          <h3>Total Users</h3>
          <div className="stat-value">{stats.users.total}</div>
          <div className="stat-breakdown">
            <div className="stat-breakdown-item">
              <span>Free:</span>
              <strong>{stats.users.free}</strong>
            </div>
            <div className="stat-breakdown-item">
              <span>Trial:</span>
              <strong>{stats.users.trial}</strong>
            </div>
            <div className="stat-breakdown-item">
              <span>Active Subscribers:</span>
              <strong>{stats.users.active}</strong>
            </div>
          </div>
        </div>

        {/* Users by Tier Card */}
        <div className="stat-card">
          <h3>Users by Tier</h3>
          <div className="stat-breakdown" style={{ paddingTop: 0 }}>
            <div className="stat-breakdown-item">
              <span>Pilgrim (Free):</span>
              <strong>{stats.users.byTier.pilgrim}</strong>
            </div>
            <div className="stat-breakdown-item">
              <span>Disciple ($4.99):</span>
              <strong>{stats.users.byTier.disciple}</strong>
            </div>
            <div className="stat-breakdown-item">
              <span>Companion ($9.99):</span>
              <strong>{stats.users.byTier.companion}</strong>
            </div>
            <div className="stat-breakdown-item">
              <span>Retreatant ($14.99):</span>
              <strong>{stats.users.byTier.retreatant}</strong>
            </div>
          </div>
        </div>

        {/* Active Conversations Card */}
        <div className="stat-card">
          <h3>Active Conversations</h3>
          <div className="stat-breakdown" style={{ paddingTop: 0 }}>
            <div className="stat-breakdown-item">
              <span>Last 24 hours:</span>
              <strong>{stats.conversations.last24h}</strong>
            </div>
            <div className="stat-breakdown-item">
              <span>Last 7 days:</span>
              <strong>{stats.conversations.last7d}</strong>
            </div>
            <div className="stat-breakdown-item">
              <span>Last 30 days:</span>
              <strong>{stats.conversations.last30d}</strong>
            </div>
          </div>
        </div>

        {/* Conversations by Tier (30 days) */}
        <div className="stat-card">
          <h3>Conversations by Tier (30d)</h3>
          <div className="stat-breakdown" style={{ paddingTop: 0 }}>
            <div className="stat-breakdown-item">
              <span>Pilgrim:</span>
              <strong>{stats.conversations.byTier.pilgrim}</strong>
            </div>
            <div className="stat-breakdown-item">
              <span>Disciple:</span>
              <strong>{stats.conversations.byTier.disciple}</strong>
            </div>
            <div className="stat-breakdown-item">
              <span>Companion:</span>
              <strong>{stats.conversations.byTier.companion}</strong>
            </div>
            <div className="stat-breakdown-item">
              <span>Retreatant:</span>
              <strong>{stats.conversations.byTier.retreatant}</strong>
            </div>
          </div>
        </div>

        {/* Conversion Rate Card */}
        <div className="stat-card">
          <h3>Trial → Paid Conversion</h3>
          <div className="stat-value">{stats.conversion.rate}%</div>
          <div className="stat-breakdown">
            <div className="stat-breakdown-item">
              <span>Converted to Paid:</span>
              <strong>{stats.conversion.converted}</strong>
            </div>
            <div className="stat-breakdown-item">
              <span>Total Trial Users:</span>
              <strong>{stats.conversion.total}</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatsOverview;
